// extracted by mini-css-extract-plugin
module.exports = {"Background":"src-components-Background-Background--2Y1ar"};